import React from 'react';

interface BadgeProps {
  value: string;
}

const badgeColors = {
  'cash': '#4CAF50',
  'real_estate': '#2196F3',
  'vehicle': '#FF9800',
  'jewelry': '#9C27B0',
  'artwork': '#E91E63',
  'other': '#9E9E9E',
  'dog': '#795548',
  'cat': '#607D8B',
  'bird': '#FFEB3B',
  'fish': '#00BCD4',
  'reptile': '#8BC34A',
};

export function Badge({ value }: BadgeProps) {
  const style = { background: badgeColors[value] };

  return (
    <span className="badge" style={style}>
      {value}
    </span>
  );
}
